import { MethodShipments, LotPickMethodShipments, SublotPickMethodShipments, UnitPickMethodShipments, PickSequence } from "../../../../../enum/TransactionDataEntryEnum";
import { ShowMasterLot, TransactionStageEnum } from "../../../../../enum/Enum";
export const populateTransactionDetailObjects = (objects, config) => {
    const {
        headerFormFields,
        detailFormFields,
        pickMethods,
        profile,
        fromStage = TransactionStageEnum.Plan
    } = config;

    objects.forEach(obj => {
        obj.RTransactionHeader = headerFormFields.ROWID;
        obj.HeaderRowId = headerFormFields.ROWID;
        obj.TransactionType = headerFormFields.TRANSACTIONTYPE;
        obj.FromStage = fromStage;
        obj.Stage = headerFormFields.STAGE;
        obj.DetailRowId = detailFormFields.ROWID;
        obj.SubDetailRowId = null;
        obj.DefaultReceiptWH = null;
        obj.ReceiptLocationMethod = profile?.LocationmethodReceipts;
        obj.LocationMethod = pickMethods.LocationMethod ?? MethodShipments.AutoSelect;
        obj.LocationPickMethod = pickMethods.LocationPickMethod;
        obj.LocationPickSequence = pickMethods.LocationPickSeqMethod;
        obj.LotMethod = pickMethods.LotMethod ?? MethodShipments.Manual;
        obj.LotPickMethod = pickMethods.LotPickMethod ?? LotPickMethodShipments.LotCode;
        obj.LotPickSequence = pickMethods.LotPickSeqMethod;
        obj.SublotMethod = pickMethods.SublotMethod;
        obj.SublotPickMethod = pickMethods.SublotPickMethod ?? SublotPickMethodShipments.SublotCode;
        obj.SublotPickSequence = pickMethods.SublotPickSeqMethod ?? PickSequence.Ascending;
        obj.UnitMethod = pickMethods.UnitMethod;
        obj.UnitPickMethod = pickMethods.UnitPickMethod ?? UnitPickMethodShipments.UnitCode;
        obj.UnitPickSequence = pickMethods.UnitPickSeqMethod ?? PickSequence.Ascending;
        obj.ShipmentsOnNegAvl = profile?.ShipmentsonnegAvl ?? ShowMasterLot.None;
        obj.Mode = ShowMasterLot.None;
    });

    return objects;
};
